import React from "react";
import Navbar from "../components/Navbar";

const News = () => {
  document.body.style = "background-color: #FAFCFE";
  return (
    <>
      <header>
        <Navbar userName={"Jack"} />
      </header>
      <main className="main">
        <h1>News - WIP</h1>
      </main>
    </>
  );
};

export default News;
